__turbopack_context__.v({
  "actions": "AddZone-module__YN5t9G__actions",
  "choice": "AddZone-module__YN5t9G__choice",
  "choiceBtn": "AddZone-module__YN5t9G__choiceBtn",
  "choiceBtnActive": "AddZone-module__YN5t9G__choiceBtnActive",
  "container": "AddZone-module__YN5t9G__container",
  "empty": "AddZone-module__YN5t9G__empty",
  "group": "AddZone-module__YN5t9G__group",
  "groupLabel": "AddZone-module__YN5t9G__groupLabel",
  "groups": "AddZone-module__YN5t9G__groups",
  "presetAdd": "AddZone-module__YN5t9G__presetAdd",
  "presetBtn": "AddZone-module__YN5t9G__presetBtn",
  "presetDelete": "AddZone-module__YN5t9G__presetDelete",
  "presetDot": "AddZone-module__YN5t9G__presetDot",
  "presetName": "AddZone-module__YN5t9G__presetName",
  "presetRow": "AddZone-module__YN5t9G__presetRow",
  "presets": "AddZone-module__YN5t9G__presets",
  "tabBody": "AddZone-module__YN5t9G__tabBody",
});
